<p>
  six-arts-management works!
</p>

<h1 class="display 4"> Staff Portal</h1>
<form #form="ngForm" autocomplete="off">
  <div class="form group">
    <input name="id" #name="ngModel" [(ngModel)]="courseService.formData.id" class="form-control" placeholder="id">
  </div>
  <div class="form group">
    <input name="name" #name="ngModel" [(ngModel)]="courseService.formData.name" class="form-control" placeholder="name">
  </div>
  <div class="form-row">
    <div class="form group">
      <input name="day" #name="ngModel" [(ngModel)]="courseService.formData.day" class="form-control" placeholder="day">
    </div>
    <div class="form group">
      <input name="time" #name="ngModel" [(ngModel)]="courseService.formData.times" class="form-control" placeholder="time">
    </div>

  </div>


  <!-- <table class="table table-hover">

    <thead>
      <th>Name</th>
      <th>id</th>
    </thead>
    <tbody>
      <tr *ngFor="let record of record$ | async">
        <td>{{record.id}}</td>
      </tr>
    </tbody>
  </table> -->
  <div class="container">
    <div class="row" *ngFor="let record of record$ | async">
      <div class="col-sm timetable" *ngFor="let day of weekdays">
        <h3 class="timetableTitle">{{ day }}</h3>
        <ng-container *ngFor="let course of course$ | async">
          <div
            [style.background-color]="colors[course.color]"
            class="courseDetail"
            *ngIf="course.day == day"
            [routerLink]="['/six-arts/manage/', record.id, course.id]"
            fragment="six-arts-logo"
          >
            <p class="timetableTxt">{{ course.name }}</p>
            <p class="timetableTxt">{{ course.time }}</p>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <!-- <div class="form group">
    <input name="description" #name="ngModel" [(ngModel)]="courseService.formData.description" class="form-control" placeholder="內容">
  </div>
  <div class="form group">
    <input name="teacher" #name="ngModel" [(ngModel)]="courseService.formData.teacher" class="form-control" placeholder="學費">
  </div>
  <div class="form group">
    <input name="target" #name="ngModel" [(ngModel)]="courseService.formData.target" class="form-control" placeholder="導師">
  </div>
  <div class="form group">
    <input name="dayt" #name="ngModel" [(ngModel)]="courseService.formData.dayt" class="form-control" placeholder="日期">
  </div>
  <div class="form group">
    <input name="timet" #name="ngModel" [(ngModel)]="courseService.formData.timet" class="form-control" placeholder="時間">
  </div>
  <div class="form-group">
    <button type="submit" class="btn.btn-lg.btn-block.btn-info"> Submit </button>
  </div> -->
</form>


<div class="container">
  <div class="row" *ngFor="let record of record$ | async">
    {{record.id}}
    <!-- <div class="col-sm timetable" *ngFor="let day of weekdays">
      <h3 class="timetableTitle">{{ day }}</h3>
      <ng-container *ngFor="let course of course$ | async">
        <div
          [style.background-color]="colors[course.color]"
          class="courseDetail"
          *ngIf="course.day == day"
          [routerLink]="['/six-arts', record.id, course.id]"
          fragment="six-arts-logo"
        >
          <p class="timetableTxt">{{ course.name }}</p>
          <p class="timetableTxt">{{ course.time }}</p>
        </div>
      </ng-container>
    </div> -->
  </div>
</div>

<!-- <div *ngFor="let course of courses">
  {{course}}
  {{apr19}}
</div> -->
